import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const TableHead = ({className, ...rest}) => {
  return <thead className={classnames('o-table__table-header', 'u-display_flex', className)} {...rest} />;
};

TableHead.propTypes = {
  className: PropTypes.string
};

export default TableHead;
